import { useState } from 'react';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import Rupee from '../../../../Assets/Modals/RupeeBlack.svg';
import RupeeGray from '../../../../Assets/Modals/RupeeGray.svg';

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers";
import { CalendarIcon } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setActionAlert, setActiveSection } from '../../../../Features/dropTrackProductsSlice';
import { adjustPrice, adjustPriceNoDates } from '../../../../lib/utils/apiCalls';
import { formatDate } from '../../../../lib/utils/utils';
import { useLocation, useNavigate } from 'react-router-dom';

import { showToast } from '../../../../Components/Toaster/Toaster';

function AdjustProductPriceForm() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const defaultFormErrors = {
        newPrice: '',
        date: '',
    };

    const activeProduct = useSelector((state) => state.dropTrackProducts.activeProduct);
    
    const dates = {
        from: null,
        to: null,
    }

    const [date, setDate] = useState(dates);
    const [newPrice, setNewPrice] = useState('');
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const handlePricechange = (e) => {
        setNewPrice(e.target.value);
    }

    const handleResponse = async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.statusCode == 10000) {
            showToast('Adjust product price succcessful!', 'success');
            dispatch(closeModal());
            navigate(`${location.pathname}/${activeProduct.productId}`);
            dispatch(setActionAlert({
                type: 'Adjust Product Price',
                startDate: formatDate(response.data.startDate),
                endDate: formatDate(response.data.endDate),
            }));
            dispatch(setActiveSection('insights'));
        }
    };

    const handleNotifyButton = async () => {
        const validationErrors = {};

        const fromDate = new Date(date.from);
        const toDate = new Date(date.to);

        const fromTimestamp = fromDate.getTime();
        const toTimestamp = toDate.getTime();

        if(!newPrice.trim()) {
            validationErrors.newPrice = 'Please Enter a price';
        }

        if(fromTimestamp || toTimestamp) {
            if(!fromTimestamp) {
                validationErrors.date = 'Select Start Date';
            }
            else if(!toTimestamp) {
                validationErrors.date = 'Select End Date';
            }
            else if(fromDate > toDate) {
                validationErrors.date = 'Start date should be earlier than End date';
            }
        }

        if(Object.keys(validationErrors).length === 0) {
            if(fromTimestamp && toTimestamp) {
                const callData = {
                    productId: activeProduct.productId,
                    prevPrice: activeProduct.currentPrice,
                    newPrice: newPrice,
                    fromDate: fromDate.toISOString(),
                    toDate: toDate.toISOString()
                };
    
                try {
                    const response = await adjustPrice(callData);
                    await handleResponse(response);
                }
                catch (err) {
                    showToast(`Error occurred`, 'error');
                }
            }
            else {
                const callData = {
                    productId: activeProduct.productId,
                    prevPrice: activeProduct.currentPrice,
                    newPrice: newPrice,
                };

                try {
                    const response = await adjustPriceNoDates(callData);
                    await handleResponse(response);
                }
                catch (err) {
                    showToast(`Error occurred`, 'error');
                }
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    return (
        <div className="w-1/2 h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-5">
            <div className="flex items-center justify-between">
                <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Adjust Product Price</h1>

                <button onClick={handleButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="flex flex-col gap-10">
                <form action="" className="flex flex-col gap-3">
                    <div className="flex flex-col gap-2 font-urbanist-regular">
                        <h1 className='font-medium text-base text-[#000000]'>Current Price</h1>
                        
                        <div className="flex items-center gap-1">
                            <div className="w-6 h-6 flex items-center justify-center">
                                <img src={Rupee} alt="Rupee" />
                            </div>

                            <p className='font-semibold text-base text-[#121212]'>{activeProduct.currentPrice}</p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <div className="flex items-center justify-between">
                            <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="price-input">Add New Price</label>

                            {formErrors.newPrice && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.newPrice}</p>}
                        </div>

                        <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center gap-1 focus-within:border-primaryColor">
                            <div className="w-6 h-6 flex items-center justify-center">
                                <img src={RupeeGray} alt="Rupee" />
                            </div>

                            <input value={newPrice} onChange={handlePricechange} className='bg-transparent flex-grow outline-none border-none text-sm font-medium placeholder:text-[#666666]' id='price-input' placeholder='0.00' type="number" />
                        </div>
                    </div>

                    <div className="flex flex-col gap-2 font-urbanist-regular">
                        <div className="flex items-center justify-between">
                            <h1 className='font-medium text-[16px] leading-8 text-[#121212]'>
                                Set Duration 
                                &#40;optional&#41;
                            </h1>

                            {formErrors.date && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.date}</p>}
                        </div>
                    
                        <p className='font-medium text-[16px] leading-[28px] text-[#666666]'>
                            Specify your deal's duration and let the system automatically revert to standard pricing post-promotion. Effortless timing for impactful sales
                        </p>
                    </div>

                    <div className="flex gap-8 text-black font-urbanist-regular">
                        <div className="flex flex-col gap-1">
                            <h1 className='font-normal text-base'>From</h1>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        label="Start Date" 
                                        onChange={e => setDate({ ...date, from: e.$d })} 
                                        slots={{ openPickerIcon: CalendarIcon }} 
                                        sx={{
                                            width: '180px'
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </div>

                        <div className="flex flex-col gap-1">
                            <h1 className='font-normal text-base'>To</h1>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        label="End Date" 
                                        onChange={e => setDate({ ...date, to: e.$d })} 
                                        slots={{ openPickerIcon: CalendarIcon, }} 
                                        sx={{
                                            width: '180px',
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </div>
                    </div>
                </form>

                <button onClick={handleNotifyButton} className='bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded font-semibold text-base text-center text-buttonText' type='button'>
                    Notify DropTrack Watchers
                </button>
            </div>
        </div>
    );
}

export default AdjustProductPriceForm;
